<kt-splash-screen></kt-splash-screen>
<router-outlet></router-outlet>
